<template lang="pug">
form.form-body-follow
  .row
    table(style='width: 100%')
      tr
        td(style='width: 33%').total-title
          a(href="#" @click="clickFollowing").color-brown {{numberWithCommas(following[1])}}
        td(style='width: 33%').total-title
          a(href="#" @click.prevent="clickFollowed()").color-green {{numberWithCommas(followed[1])}}
        td(style='width: 33%').total-title
          a(href="#" @click.prevent="clickFavoriteAnswer()").color-red {{numberWithCommas(1250)}}/{{numberWithCommas(2120)}}
      tr
        td.txt-follow Đang theo dõi
        td.txt-follow Được theo dõi 
        td.txt-follow Câu trả lời được yêu thích
      
//- .row
//-   .col-md-4
//-     md-fg-input(label='City', :labelFloating='true', v-model='user.city')
//- .row
//-   .col-md-12
//-     md-fg-input(type='textarea', label='About Me', :labelFloating='true', :rows='5', v-model='user.aboutMe')
//- md-button.btn.btn-primary.pull-right(@click.prevent='updateProfile') Update Profile
</template>

<script>
import mdFollow from './modalFollow'
import mdFollowed from './modalFollowed'

export default {
  props: {
    following: Array,
    followed: Array
  },
  methods: {
    numberWithCommas(number) {
      if (number !== undefined) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    },
    clickFollowing() {
      // console.log('dang theo doi')
      this.$modal.show(mdFollow, {
        title: 'ĐANG THEO DÕI'
      }, {
        height: 'auto',
        scrollable: true,
        clickToClose: false,
        pivotY: 0.1,
        classes: ['col-md-12']
      })
    },
    clickFollowed() {
      // console.log('duoc theo doi')
      this.$modal.show(mdFollowed, {
        title: 'ĐƯỢC THEO DÕI'
      }, {
        height: 'auto',
        classes: ['col-md-12'],
        scrollable: true,
        clickToClose: false,
        pivotY: 0.1
      })
    },
    clickFavoriteAnswer() {
      // console.log('cau tra loi duoc yeu thich')
    //   this.$modal.show(mdFollow, {
    //     title: 'ĐÃ YÊU THÍCH CÂU TRẢ LỜI CỦA BẠN'
    //   }, {
    //     height: 'auto',
    //     width: '570px',
    //     left: '0px',
    //     scrollable: true,
    //     clickToClose: false,
    //     pivotY: 0.3
    //   })
    }
  }
}
</script>

<style lang='scss'>
.form-body-follow {
  margin-top: 15px;
}
.total-title {
  text-align:center;
  font-weight: bold;
}
.txt-follow {
  text-align:center;
  vertical-align: text-top;
  // font-family: Proxima Nova;
  color: #9B9B9B;
  // font-size: 13px;
}
.color-brown {
  color: brown
}
.color-red {
  color: red
}
.color-green {
  color: green
}
</style>



// WEBPACK FOOTER //
// Follow.vue?aaca0822